export default "/images/2.png?0fa294d4376c749281f4e9e6fd8e1eeb";